import { createApp } from "vue";
// import * as Vue from 'vue' // in Vue 3
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "@vueform/multiselect/themes/default.css"
import ArgonDashboard from "./argon-dashboard";
import Datepicker from '@vuepic/vue-datepicker';
import Multiselect from '@vueform/multiselect';
import Notifications from '@kyvg/vue3-notification'

const defaultApiBaseUrl =
  process.env.NODE_ENV === "production"
    ? "/mid-api/sanko/"
    : "http://127.0.0.1:58024/mid-api/sanko/";

axios.defaults.baseURL =
  process.env.VUE_APP_API_BASE_URL || defaultApiBaseUrl;

const appInstance = createApp(App);
appInstance.component('Datepicker', Datepicker);
appInstance.component('Multiselect', Multiselect);
appInstance.use(VueAxios, axios)
appInstance.use(Notifications);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.use(Multiselect);
appInstance.mount("#app");
